import { render, staticRenderFns } from "./personalizedPlan.vue?vue&type=template&id=33af6d16&scoped=true"
import script from "./personalizedPlan.vue?vue&type=script&lang=js"
export * from "./personalizedPlan.vue?vue&type=script&lang=js"
import style0 from "./personalizedPlan.vue?vue&type=style&index=0&id=33af6d16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af6d16",
  null
  
)

export default component.exports